export default class AttachmentUploadRequestRevokedError extends Error {

}